/*
 * Poespas Home — eigen favorieten. Claude 24-09-2026.
 * Gebaseerd op de poespas.nl-opzet, zonder maten/restock (behang = print on demand).
 * ----------------------------------------------------------------------------
 * - Uitgelogd: lijstje staat in localStorage (+ anoniem via guest_token naar de
 *   backend voor de insights-telling).
 * - Ingelogd: het ACCOUNT is de waarheid. Eénmalig per login worden de gast-
 *   favorieten samengevoegd (/merge); daarna haalt elke pagina het lijstje op
 *   (/list) en overschrijft de lokale kopie → sync tussen telefoon en laptop,
 *   en verwijderen op apparaat A blijft ook weg op apparaat B.
 * - Uitloggen: lokale kopie van het account wordt gewist (gedeelde apparaten).
 * - Backend = Shopify App Proxy /apps/favorieten → insights. Faalt stil als die
 *   (nog) niet bereikbaar is; de front-end blijft dan gewoon lokaal werken.
 */
(function () {
  'use strict';

  var KEY = 'pp_favorieten';
  var KEY_GUEST = 'pp_guest_token';
  var KEY_ACCOUNT = 'pp_fav_account'; // customer-id waarvoor al is samengevoegd
  var CFG = window.PP_FAV_CONFIG || {};
  var API = CFG.apiBase || '/apps/favorieten';
  var CUSTOMER = CFG.customerId ? String(CFG.customerId) : null;
  var lastLocalChange = 0;

  /* ---------- opslag ---------- */
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }

  function read() {
    try {
      var arr = JSON.parse(lsGet(KEY) || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(items) {
    lsSet(KEY, JSON.stringify(items));
    updateCounts(items.length);
    document.dispatchEvent(new CustomEvent('pp:favorieten:changed', { detail: { count: items.length } }));
  }
  function has(items, id) {
    return items.some(function (it) { return String(it.id) === String(id); });
  }
  function guestToken() {
    var t = lsGet(KEY_GUEST);
    if (!t) {
      t = 'g_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      lsSet(KEY_GUEST, t);
    }
    return t;
  }
  function itemFromButton(btn) {
    var d = btn.dataset;
    return {
      id: d.productId,
      handle: d.handle || '',
      url: d.url || '',
      title: d.title || '',
      image: d.image || '',
      price: d.price ? parseInt(d.price, 10) : null,
      priceVaries: d.priceVaries === 'true',
      perM2: d.perM2 === 'true',
      addedAt: new Date().toISOString()
    };
  }

  /* ---------- backend (defensief) ---------- */
  function api(path, method, body) {
    var url = API + path;
    body = body || null;
    if (!CUSTOMER) {
      if (method === 'GET') url += (url.indexOf('?') === -1 ? '?' : '&') + 'guest_token=' + encodeURIComponent(guestToken());
      else if (body) body.guest_token = guestToken();
    } else if (body) {
      body.customer_email = CFG.customerEmail || null;
      body.customer_name = CFG.customerName || null;
    }
    return fetch(url, {
      method: method || 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: body ? JSON.stringify(body) : undefined
    })
      .then(function (r) { return r.ok ? r.json().catch(function () { return null; }) : null; })
      .catch(function () { return null; });
  }
  function syncToggle(item, active) {
    var body = {
      product_id: item.id, active: active, title: item.title, image: item.image,
      price: item.price, handle: item.handle, url: item.url
    };
    if (Array.isArray(item.rooms)) body.rooms = item.rooms; // alleen meesturen als bekend
    return api('/toggle', 'POST', body);
  }
  function adoptServerList(res, startedAt) {
    if (!res || !res.ok || !Array.isArray(res.items)) return false;
    if (lastLocalChange > startedAt) return false; // intussen lokaal gewijzigd → niet overschrijven
    var prev = {};
    read().forEach(function (x) { prev[String(x.id)] = x; });
    write(res.items.map(function (it) {
      return {
        id: String(it.id), handle: it.handle || '', url: it.url || '', title: it.title || '',
        image: it.image || '', price: it.price, priceVaries: !!(prev[String(it.id)] || {}).priceVaries,
        rooms: Array.isArray(it.rooms) ? it.rooms : ((prev[String(it.id)] || {}).rooms || []), addedAt: it.addedAt
      };
    }));
    rerender();
    return true;
  }

  /* ---------- account-sync ---------- */
  function syncAccount() {
    var merged = lsGet(KEY_ACCOUNT);
    if (!CUSTOMER) {
      if (merged) { lsDel(KEY_ACCOUNT); write([]); rerender(); } // uitgelogd
      return;
    }
    var startedAt = Date.now();
    if (merged !== CUSTOMER) {
      // eerste keer ingelogd (op dit apparaat): gast-lijstje meenemen naar account
      api('/merge', 'POST', { items: read(), guest_token: lsGet(KEY_GUEST) }).then(function (res) {
        if (adoptServerList(res, startedAt)) lsSet(KEY_ACCOUNT, CUSTOMER);
      });
    } else {
      api('/list', 'GET').then(function (res) { adoptServerList(res, startedAt); });
    }
  }

  /* ---------- hartjes ---------- */
  function refreshButtons() {
    var items = read();
    var btns = document.querySelectorAll('[data-pp-fav]');
    for (var i = 0; i < btns.length; i++) {
      var active = has(items, btns[i].dataset.productId);
      btns[i].classList.toggle('is-active', active);
      btns[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      btns[i].setAttribute('aria-label', active ? 'Verwijder uit favorieten' : 'Bewaar als favoriet');
      var label = btns[i].querySelector('[data-pp-fav-label]');
      if (label) label.textContent = active ? 'Bewaard in favorieten' : 'Bewaar als favoriet';
    }
  }
  // Header-hartje: roze gevuld zodra er favorieten zijn (geen teller)
  function updateCounts(n) {
    var els = document.querySelectorAll('[data-pp-fav-header]');
    for (var i = 0; i < els.length; i++) {
      els[i].classList.toggle('has-favorieten', n > 0);
      els[i].setAttribute('aria-label', n > 0 ? 'Mijn favorieten (' + n + ')' : 'Mijn favorieten');
    }
  }
  function toggle(btn) {
    var items = read();
    var item = itemFromButton(btn);
    var active = !has(items, item.id);
    if (active) {
      items.push(item);
      btn.classList.remove('pp-fav--pop');
      void btn.offsetWidth;
      btn.classList.add('pp-fav--pop');
    } else {
      items = items.filter(function (it) { return String(it.id) !== String(item.id); });
    }
    lastLocalChange = Date.now();
    write(items);
    refreshButtons();
    syncToggle(item, active);
  }

  /* ---------- favorietenpagina ---------- */
  // Prijs zoals op de collectiepagina: €40/m² bij behang op maat, anders (vanaf) vaste prijs
  function priceLabel(it) {
    if (it.perM2) return (it.priceVaries ? 'Vanaf ' : '') + '€' + (it.price / 100).toFixed(2).replace('.00', '').replace('.', ',') + '<span class="pp-favcard__unit">/m²</span>';
    return (it.priceVaries ? 'Vanaf ' : '') + money(it.price);
  }
  function money(cents) {
    if (cents == null) return '';
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Gedeeld lijstje uit de link (?lijst=handle,handle,...) — alleen bekijken
  // Twee soorten deellinks: kort ?l=<code> (via insights) of lang ?lijst=h1,h2&kamer=Babykamer (terugval)
  var SHARE_CODE = null, SHARED_TITLE = null;
  function sharedItem(h, rooms) {
    return { id: 'h:' + h, handle: h, url: '/products/' + h, title: '', image: '', price: null, rooms: rooms || [] };
  }
  var SHARED = (function () {
    try {
      var qs = new URLSearchParams(window.location.search);
      var code = qs.get('l');
      if (code) { SHARE_CODE = code.replace(/[^a-z0-9]/gi, '').slice(0, 16); return []; }
      var p = qs.get('lijst');
      if (!p) return null;
      var kamer = (qs.get('kamer') || '').trim().slice(0, 120);
      SHARED_TITLE = kamer || null;
      var rooms = kamer && kamer.indexOf(' & ') === -1 ? [kamer] : [];
      return p.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, 60)
        .map(function (h) { return sharedItem(h, rooms); });
    } catch (e) { return null; }
  })();

  function renderList(container) {
    var grid = container.querySelector('[data-pp-favlist-grid]');
    var empty = container.querySelector('[data-pp-favlist-empty]');
    if (!grid) return;
    var all = SHARED || read().slice().reverse(); // nieuwste eerst
    renderRoomFilter(container, all);
    var items = (!SHARED && FILTER) ? all.filter(function (it) { return hasRoom(it, FILTER); }) : all;
    if (empty) empty.hidden = all.length > 0 || !!SHARED;
    var shareListBtn = container.querySelector('[data-pp-share-list]');
    if (shareListBtn) shareListBtn.hidden = !!SHARED || all.length === 0;
    grid.innerHTML = items.map(function (it) {
      var url = esc(it.url || ('/products/' + it.handle));
      return (
        '<div class="pp-favcard" data-pp-favcard data-product-id="' + esc(it.id) + '" data-title="' + esc(it.title) + '" data-handle="' + esc(it.handle) + '" data-url="' + url + '">' +
          '<div class="pp-favcard__tools">' +
            '<button type="button" class="pp-favcard__tool" data-pp-fav-share aria-label="Delen">' + ICON_SHARE + '</button>' +
            (SHARED ? '' :
            '<button type="button" class="pp-favcard__tool" data-pp-fav-remove aria-label="Verwijder uit favorieten">' +
              '<svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg>' +
            '</button>') +
          '</div>' +
          '<a class="pp-favcard__media" href="' + url + '">' +
            (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="pp-favcard__body">' +
            '<h3 class="pp-favcard__title"><a href="' + url + '">' + esc(it.title) + '</a></h3>' +
            (it.price != null ? '<p class="pp-favcard__price" data-pp-price>' + priceLabel(it) + '</p>' : '') +
            (SHARED ? '' :
              '<div class="pp-favcard__rooms">' +
                ((it.rooms || []).length
                  ? (it.rooms || []).map(function (r) {
                      return '<span class="pp-room-tag">' +
                        '<button type="button" class="pp-room-tag__name" data-pp-fav-rooms title="Kamers wijzigen">' + ICON_TAG + esc(r) + '</button>' +
                        '<button type="button" class="pp-room-tag__x" data-pp-room-remove="' + esc(r) + '" aria-label="' + esc(r) + ' weghalen bij dit behang">' +
                          '<svg viewBox="0 0 20 20" width="9" height="9" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg>' +
                        '</button></span>';
                    }).join('') +
                    '<button type="button" class="pp-room-add pp-room-add--small" data-pp-fav-rooms aria-label="Kamer toevoegen of wijzigen">' + ICON_PLUS + '</button>'
                  : '<button type="button" class="pp-room-add" data-pp-fav-rooms>' + ICON_TAG + '<span class="pp-hide-sm">Voeg toe aan kamer</span><span class="pp-show-sm">Kamer</span></button>') +
              '</div>') +
            '<button type="button" class="pp-favcard__btn" data-pp-fav-sample hidden>Staaltje bestellen • €3,50</button>' +
            '<a class="pp-favcard__btn pp-favcard__btn--ghost" href="' + url + '" data-pp-fav-view>Naar behang</a>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }
  /* ---------- staaltjes ---------- */
  var ICON_SHARE = '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2.5v10M6.5 6 10 2.5 13.5 6"/><path d="M5 9.5H4.5A1.5 1.5 0 0 0 3 11v5a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 17 16v-5a1.5 1.5 0 0 0-1.5-1.5H15"/></svg>';
  var sampleCache = {};
  function loadSample(handle) {
    if (!sampleCache[handle]) {
      sampleCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=pp-staaltje', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d || null; })
        .catch(function () { return null; });
    }
    return sampleCache[handle];
  }
  function showSampleButtons(container) {
    container.querySelectorAll('[data-pp-favcard]').forEach(function (card) {
      var h = card.getAttribute('data-handle');
      if (!h) return;
      loadSample(h).then(function (d) {
        if (d && typeof d.per_m2 === 'boolean' && !SHARED) {
          var pid = card.getAttribute('data-product-id'), items = read(), hit = false;
          items.forEach(function (x) { if (String(x.id) === String(pid) && !!x.perM2 !== d.per_m2) { x.perM2 = d.per_m2; hit = true; } });
          if (hit) { write(items); var pe = card.querySelector('[data-pp-price]'); var it = items.filter(function (x) { return String(x.id) === String(pid); })[0]; if (pe && it) pe.innerHTML = priceLabel(it); }
        } else if (d && SHARED) {
          var sp = SHARED.filter(function (x) { return x.handle === h; })[0];
          if (sp) { sp.perM2 = !!d.per_m2; var pe2 = card.querySelector('[data-pp-price]'); if (pe2 && sp.price != null) pe2.innerHTML = priceLabel(sp); }
        }
        var s = d && d.staaltje && d.staaltje.variants.length ? d.staaltje : null;
        var b = card.querySelector('[data-pp-fav-sample]');
        if (!b) return;
        if (!s) { // geen staaltje gekoppeld → 'Bekijk behang' wordt de hoofdknop
          var v = card.querySelector('[data-pp-fav-view]');
          if (v) v.classList.remove('pp-favcard__btn--ghost');
          return;
        }
        var p = Math.min.apply(null, s.variants.map(function (v) { return v.price; }));
        b.innerHTML = 'Staaltje<span class="pp-hide-sm">&nbsp;bestellen</span>&nbsp;• ' + money(p).replace(',00', ',-').replace('€ ', '€');
        b.hidden = false;
      });
    });
  }
  function openSampleSheet(card) {
    var title = card.getAttribute('data-title');
    loadSample(card.getAttribute('data-handle')).then(function (d) {
      var s = d && d.staaltje && d.staaltje.variants.length ? d.staaltje : null;
      if (!s) return;
      var rows = s.variants.map(function (v, i) {
        return '<label class="pp-check' + (v.available ? '' : ' is-disabled') + '">' +
          '<input type="checkbox" value="' + v.id + '" data-price="' + v.price + '"' + (i === 0 && v.available ? ' checked' : '') + (v.available ? '' : ' disabled') + '>' +
          '<span class="pp-check__label">' + esc(v.material) + '</span>' +
          '<span class="pp-check__price">' + money(v.price) + '</span></label>';
      }).join('');
      var body = openSheet('Staaltje bestellen',
        '<p class="pp-sheet__text">Kies een of meer materialen voor <strong>' + esc(title) + '</strong>.</p>' +
        '<div class="pp-checks">' + rows + '</div>' +
        '<div class="pp-sheet__actions"><button type="button" class="pp-favcard__btn" data-pp-sample-add>In winkelmand</button></div>');
      var btn = body.querySelector('[data-pp-sample-add]');
      var ICON_CART = '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.4 6.9h13.2v8a2.1 2.1 0 0 1-2.1 2.1h-9a2.1 2.1 0 0 1-2.1-2.1zM8.8 3h2.4a2.3 2.3 0 0 1 2.3 2.3v1.6H6.5V5.3A2.3 2.3 0 0 1 8.8 3"/></svg>';
      function sync() {
        var checked = body.querySelectorAll('input:checked');
        var n = checked.length;
        var total = Array.prototype.reduce.call(checked, function (s, i) { return s + parseInt(i.getAttribute('data-price'), 10); }, 0);
        btn.disabled = n === 0;
        btn.innerHTML = ICON_CART + '<span>' + (n === 0 ? 'Kies een materiaal'
          : 'Voeg ' + (n === 1 ? 'staaltje' : n + ' staaltjes') + ' toe (' + money(total) + ')') + '</span>';
      }
      body.addEventListener('change', sync); sync();
      btn.addEventListener('click', function () {
        var ids = Array.prototype.map.call(body.querySelectorAll('input:checked'), function (i) { return parseInt(i.value, 10); });
        if (!ids.length) return;
        btn.disabled = true; btn.textContent = 'Toevoegen…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1, properties: { Type: 'Staaltje' } }; }) })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js').then(function (c) { return c.json(); }); })
          .then(function (cart) {
            // op de pagina blijven: knop bevestigt, winkelmand-teller in de header wordt bijgewerkt
            btn.innerHTML = 'Toegevoegd aan winkelmand ✓';
            setTimeout(closeSheet, 1200);
            import('@theme/events').then(function (m) {
              document.dispatchEvent(new m.CartUpdateEvent(cart, 'pp-favorieten', { itemCount: cart.item_count, source: 'staaltje' }));
            }).catch(function () {});
          })
          .catch(function () { btn.disabled = false; btn.textContent = 'Opnieuw proberen'; });
      });
    });
  }

  /* ---------- delen ---------- */
  function share(card, forceSheet) {
    var title = card.getAttribute('data-title') || 'Poespas Home';
    var url = new URL(card.getAttribute('data-url'), window.location.origin).href;
    var text = card.getAttribute('data-text') || ('Kijk dit behang van Poespas Home: ' + title);
    if (navigator.share && !forceSheet) {
      navigator.share({ title: title, text: text, url: url }).catch(function () {});
      return;
    }
    var enc = encodeURIComponent;
    var body = openSheet('Delen',
      '<div class="pp-share">' +
        '<a class="pp-share__opt" target="_blank" rel="noopener" href="https://wa.me/?text=' + enc(text + ' ' + url) + '">WhatsApp</a>' +
        '<a class="pp-share__opt" href="mailto:?subject=' + enc(title) + '&body=' + enc(text + '\n' + url) + '">E-mail</a>' +
        '<a class="pp-share__opt" target="_blank" rel="noopener" href="https://www.pinterest.com/pin/create/button/?url=' + enc(url) + '&description=' + enc(title) + '">Pinterest</a>' +
        '<button type="button" class="pp-share__opt" data-pp-copy>Link kopiëren</button>' +
        (navigator.share ? '<button type="button" class="pp-share__opt pp-share__opt--wide" data-pp-native>Meer opties…</button>' : '') +
      '</div>');
    var nat = body.querySelector('[data-pp-native]');
    if (nat) nat.addEventListener('click', function () {
      navigator.share({ title: title, text: text, url: url }).catch(function () {});
    });
    body.querySelector('[data-pp-copy]').addEventListener('click', function (e) {
      var b = e.currentTarget;
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        b.textContent = 'Link gekopieerd';
      }).catch(function () { window.prompt('Kopieer deze link:', url); });
    });
  }

  /* ---------- kamers (labels) ---------- */
  var FILTER = null;
  // huisje = kamer (tag-icoon leek op een prijskaartje)
  var ICON_TAG = '<svg viewBox="0 0 20 20" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.6 10 3l7 5.6V16a1 1 0 0 1-1 1h-3.5v-4.5h-5V17H4a1 1 0 0 1-1-1Z"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 20 20" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg>';

  // Eénmalige uitleg-ballon die naar de eerste 'Voeg toe aan kamer'-knop wijst
  var TIP_KEY = 'pp_fav_tip_kamers';
  var tipEl = null;
  function maybeShowRoomTip(container) {
    if (SHARED || tipEl || lsGet(TIP_KEY)) return;
    if (allRooms().length) { lsSet(TIP_KEY, '1'); return; } // gebruikt het al
    var target = container.querySelector('.pp-room-add[data-pp-fav-rooms]');
    if (!target) return;
    tipEl = document.createElement('div');
    tipEl.className = 'pp-tip';
    tipEl.setAttribute('role', 'dialog');
    tipEl.innerHTML =
      '<div class="pp-tip__bubble">' +
        '<button type="button" class="pp-tip__close" data-pp-tip-close aria-label="Sluiten">' +
          '<svg viewBox="0 0 20 20" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg>' +
        '</button>' +
        '<p class="pp-tip__title">Groepeer je favorieten per kamer</p>' +
        '<p class="pp-tip__text">Zet een behang bij bijvoorbeeld "woonkamer" of "kamer Siem" en filter je lijstje per kamer.</p>' +
        '<button type="button" class="pp-tip__btn" data-pp-tip-close>Begrepen</button>' +
      '</div>';
    document.body.appendChild(tipEl);
    function place() {
      if (!tipEl) return;
      var r = target.getBoundingClientRect();
      if (!r.width) return closeTip();
      // tekstwolk met puntje linksonder, precies boven de 'Voeg toe aan kamer'-knop
      var pointX = r.left + 16 + window.scrollX, topY = r.top + window.scrollY;
      var bubble = tipEl.querySelector('.pp-tip__bubble');
      var bw = Math.min(280, window.innerWidth - 32);
      bubble.style.width = bw + 'px';
      var bh = bubble.offsetHeight;
      var bx = Math.max(16 + window.scrollX, Math.min(pointX - 26, window.scrollX + window.innerWidth - bw - 16));
      var by = topY - 14 - bh;
      bubble.style.left = bx + 'px'; bubble.style.top = by + 'px';
      bubble.style.setProperty('--tail-x', Math.max(14, Math.min(pointX - bx, bw - 28)) + 'px');
    }
    place();
    window.addEventListener('resize', place);
    tipEl._place = place;
    setTimeout(function () { if (tipEl) tipEl.classList.add('is-open'); }, 30);
  }
  function closeTip() {
    lsSet(TIP_KEY, '1');
    if (!tipEl) return;
    window.removeEventListener('resize', tipEl._place);
    tipEl.remove();
    tipEl = null;
  }
  function hasRoom(it, room) {
    return (it.rooms || []).some(function (r) { return r.toLowerCase() === room.toLowerCase(); });
  }
  function allRooms(items) {
    var seen = {}, out = [];
    (items || read()).forEach(function (it) {
      (it.rooms || []).forEach(function (r) { var k = r.toLowerCase(); if (!seen[k]) { seen[k] = 1; out.push(r); } });
    });
    return out;
  }
  function renderRoomFilter(container, items) {
    var box = container.querySelector('[data-pp-rooms]');
    if (!box) return;
    var rooms = SHARED ? [] : allRooms(items);
    if (FILTER && !rooms.some(function (r) { return r.toLowerCase() === FILTER.toLowerCase(); })) FILTER = null;
    box.hidden = rooms.length === 0;
    box.innerHTML = ['<button type="button" class="pp-rooms__chip' + (FILTER ? '' : ' is-active') + '" data-pp-room-filter="">Alles</button>']
      .concat(rooms.map(function (r) {
        var active = FILTER && FILTER.toLowerCase() === r.toLowerCase();
        return '<button type="button" class="pp-rooms__chip' + (active ? ' is-active' : '') + '" data-pp-room-filter="' + esc(r) + '">' + esc(r) + '</button>';
      })).join('');
  }
  // Kamer weghalen: bij één behang (pid) of bij alle behangen (pid = null)
  function removeRoom(name, pid) {
    var changed = [];
    var items = read().map(function (it) {
      if ((pid == null || String(it.id) === String(pid)) && hasRoom(it, name)) {
        it.rooms = (it.rooms || []).filter(function (r) { return r.toLowerCase() !== name.toLowerCase(); });
        changed.push(it);
      }
      return it;
    });
    if (!changed.length) return;
    lastLocalChange = Date.now();
    write(items);
    changed.forEach(function (it) { syncToggle(it, true); });
    rerender();
  }

  function openRoomSheet(card) {
    var pid = card.getAttribute('data-product-id');
    var item = read().filter(function (it) { return String(it.id) === String(pid); })[0];
    if (!item) return;
    var chosen = (item.rooms || []).slice();
    var options = allRooms();
    function rowsHtml() {
      return options.map(function (r) {
        var on = chosen.some(function (c) { return c.toLowerCase() === r.toLowerCase(); });
        return '<label class="pp-check"><input type="checkbox" value="' + esc(r) + '"' + (on ? ' checked' : '') + '>' +
          '<span class="pp-check__label">' + esc(r) + '</span>' +
          '<button type="button" class="pp-check__del" data-pp-room-delete="' + esc(r) + '" aria-label="Kamer ' + esc(r) + ' helemaal verwijderen" title="Kamer verwijderen">' +
            '<svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h12M8 6V4.5A1.5 1.5 0 0 1 9.5 3h1A1.5 1.5 0 0 1 12 4.5V6M6 6l.7 9.1A1.5 1.5 0 0 0 8.2 16.5h3.6a1.5 1.5 0 0 0 1.5-1.4L14 6"/></svg>' +
          '</button></label>';
      }).join('');
    }
    var body = openSheet('In welke kamer?',
      '<p class="pp-sheet__text">Voor <strong>' + esc(item.title) + '</strong>. Je kunt meerdere kamers kiezen.</p>' +
      '<div class="pp-checks" data-pp-room-list>' + rowsHtml() + '</div>' +
      '<form class="pp-room-new" data-pp-room-new><span class="pp-room-new__field"><input type="text" maxlength="40" placeholder="Woonkamer…" aria-label="Nieuwe kamer"></span>' +
      '<button type="submit" class="pp-favcard__btn pp-favcard__btn--ghost pp-room-new__plus" aria-label="Kamer toevoegen">' +
        '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M10 4v12M4 10h12"/></svg></button></form>' +
      '<div class="pp-sheet__actions"><button type="button" class="pp-favcard__btn" data-pp-room-save>Opslaan</button></div>');
    var list = body.querySelector('[data-pp-room-list]');
    function readChecks() {
      chosen = Array.prototype.filter.call(list.querySelectorAll('input'), function (i) { return i.checked; })
        .map(function (i) { return i.value; });
    }
    list.addEventListener('change', readChecks);
    list.addEventListener('click', function (e) {
      var del = e.target.closest('[data-pp-room-delete]');
      if (!del) return;
      e.preventDefault(); e.stopPropagation();
      var name = del.getAttribute('data-pp-room-delete');
      var used = read().filter(function (it) { return hasRoom(it, name); }).length;
      if (used > 1 && !window.confirm('Kamer "' + name + '" weghalen bij alle ' + used + ' behangen?')) return;
      removeRoom(name, null);
      options = options.filter(function (o) { return o.toLowerCase() !== name.toLowerCase(); });
      chosen = chosen.filter(function (c) { return c.toLowerCase() !== name.toLowerCase(); });
      list.innerHTML = rowsHtml();
    });
    body.querySelector('[data-pp-room-new]').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = e.currentTarget.querySelector('input');
      var name = input.value.replace(/\s+/g, ' ').trim().slice(0, 40);
      if (!name) return;
      if (!options.some(function (o) { return o.toLowerCase() === name.toLowerCase(); })) options.push(name);
      if (!chosen.some(function (c) { return c.toLowerCase() === name.toLowerCase(); })) chosen.push(name);
      list.innerHTML = rowsHtml();
      input.value = '';
    });
    body.querySelector('[data-pp-room-save]').addEventListener('click', function () {
      var input = body.querySelector('[data-pp-room-new] input');
      var pendingName = input.value.replace(/\s+/g, ' ').trim().slice(0, 40);
      if (pendingName && !chosen.some(function (c) { return c.toLowerCase() === pendingName.toLowerCase(); })) chosen.push(pendingName);
      var items = read().map(function (it) {
        if (String(it.id) === String(pid)) it.rooms = chosen.slice(0, 20);
        return it;
      });
      lastLocalChange = Date.now();
      write(items);
      var updated = items.filter(function (it) { return String(it.id) === String(pid); })[0];
      syncToggle(updated, true);
      closeSheet();
      rerender();
    });
  }

  function fillShared(container) {
    var pending = SHARED.length;
    if (!pending) { renderList(container); return; }
    SHARED.forEach(function (it) {
      fetch('/products/' + encodeURIComponent(it.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) { it.missing = true; return; }
          it.id = String(p.id); it.title = p.title; it.price = p.price; it.priceVaries = !!p.price_varies;
          it.image = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        })
        .catch(function () { it.missing = true; })
        .then(function () {
          if (--pending) return;
          SHARED = SHARED.filter(function (x) { return !x.missing; });
          renderList(container); showSampleButtons(container);
        });
    });
  }
  function shareList() {
    var rooms = allRooms();
    if (!rooms.length) return shareItems(read().slice().reverse(), null);
    // Eén lijst: 'Alles' + elke kamer direct aanvinkbaar (geen submenu)
    var body = openSheet('Wat wil je delen?',
      '<div class="pp-checks" data-pp-share-opts>' +
        '<label class="pp-check"><input type="checkbox" value="" data-pp-share-all' + (FILTER ? '' : ' checked') + '><span class="pp-check__label">Alles</span></label>' +
        rooms.map(function (r) {
          var on = FILTER && FILTER.toLowerCase() === r.toLowerCase();
          return '<label class="pp-check"><input type="checkbox" value="' + esc(r) + '"' + (on ? ' checked' : '') + '>' +
            '<span class="pp-check__label">' + ICON_TAG + ' ' + esc(r) + '</span></label>';
        }).join('') +
      '</div>' +
      '<div class="pp-sheet__actions"><button type="button" class="pp-favcard__btn" data-pp-share-go>Delen</button></div>');
    var opts = body.querySelector('[data-pp-share-opts]');
    var allBox = opts.querySelector('[data-pp-share-all]');
    var go = body.querySelector('[data-pp-share-go]');
    function roomBoxes() { return Array.prototype.slice.call(opts.querySelectorAll('input:not([data-pp-share-all])')); }
    function picked() { return roomBoxes().filter(function (i) { return i.checked; }).map(function (i) { return i.value; }); }
    function currentSpec() {
      var list = read().slice().reverse(), names = null;
      if (!allBox.checked) {
        names = picked();
        list = list.filter(function (it) { return names.some(function (n) { return hasRoom(it, n); }); });
      }
      return { list: list, names: names };
    }
    function sync() {
      go.disabled = !allBox.checked && picked().length === 0;
      if (!go.disabled) { var c = currentSpec(); prepareShareLink(shareSpec(c.list, c.names)); }
    }
    opts.addEventListener('change', function (e) {
      if (e.target === allBox && allBox.checked) roomBoxes().forEach(function (i) { i.checked = false; });
      else if (e.target !== allBox && e.target.checked) allBox.checked = false;
      sync();
    });
    sync();
    go.addEventListener('click', function () {
      var c = currentSpec();
      closeSheet();
      shareItems(c.list, c.names);
    });
  }
  // Korte deellinks: per selectie één keer maken en onthouden (zo is de link er al bij de klik op Delen)
  var shareLinkCache = {};
  function shareSpec(list, roomNames) {
    list = list.filter(function (it) { return it.handle; });
    var title = roomNames && roomNames.length ? roomNames.join(' & ') : null;
    var base = window.location.origin + window.location.pathname;
    var payload = {
      title: title,
      items: list.map(function (it) {
        var rooms = (it.rooms || []).filter(function (r) { return !roomNames || roomNames.some(function (n) { return n.toLowerCase() === r.toLowerCase(); }); });
        return { handle: it.handle, rooms: rooms };
      })
    };
    return {
      count: list.length, title: title, payload: payload, key: JSON.stringify(payload),
      text: (title ? 'Behang voor ' + title : 'Mijn favoriete behangen') + ' van Poespas Home (' + list.length + ')',
      longUrl: base + '?lijst=' + list.map(function (it) { return encodeURIComponent(it.handle); }).join(',') +
        (title ? '&kamer=' + encodeURIComponent(title) : ''),
      base: base
    };
  }
  function prepareShareLink(spec) {
    var entry = shareLinkCache[spec.key];
    if (entry) return entry.promise;
    entry = shareLinkCache[spec.key] = { url: null };
    entry.promise = api('/share', 'POST', JSON.parse(spec.key)).then(function (res) {
      entry.url = res && res.ok && res.code ? spec.base + '?l=' + res.code : spec.longUrl;
      return entry.url;
    });
    return entry.promise;
  }
  // Direct het deelmenu van het apparaat; lukt dat niet (bv. desktop zonder deelmenu) → eigen keuzescherm
  function nativeShare(title, text, url) {
    var card = document.createElement('div');
    card.setAttribute('data-title', title); card.setAttribute('data-url', url); card.setAttribute('data-text', text);
    if (!navigator.share) return share(card, true);
    navigator.share({ title: title, text: text, url: url }).catch(function (err) {
      if (err && err.name === 'NotAllowedError') share(card, true);
    });
  }
  function shareItems(list, roomNames) {
    var spec = shareSpec(list, roomNames);
    if (!spec.count) return;
    var entry = shareLinkCache[spec.key];
    if (entry && entry.url) return nativeShare(spec.text, spec.text, entry.url);
    // nog niet klaar: max. 0,9 s wachten (valt nog binnen de klik), anders de lange link
    var done = false;
    function go(url) { if (done) return; done = true; nativeShare(spec.text, spec.text, url || spec.longUrl); }
    setTimeout(function () { go(null); }, 900);
    prepareShareLink(spec).then(go);
  }
  function adoptAllShared(btn) {
    var items = read();
    var added = 0;
    SHARED.forEach(function (it) {
      if (!it.id || it.id.indexOf('h:') === 0 || has(items, it.id)) return;
      var item = { id: it.id, handle: it.handle, url: it.url, title: it.title, image: it.image, price: it.price,
        priceVaries: it.priceVaries, rooms: (it.rooms || []).slice(), addedAt: new Date().toISOString() };
      items.push(item); added++;
      syncToggle(item, true);
    });
    // al aanwezige behangen: kamers uit het gedeelde lijstje erbij zetten
    SHARED.forEach(function (it) {
      if (!it.rooms || !it.rooms.length) return;
      items.forEach(function (x) {
        if (String(x.id) !== String(it.id)) return;
        var before = (x.rooms || []).length;
        x.rooms = (x.rooms || []).slice();
        it.rooms.forEach(function (r) { if (!hasRoom(x, r)) x.rooms.push(r); });
        if (x.rooms.length !== before) syncToggle(x, true);
      });
    });
    if (SHARE_CODE) api('/share/' + encodeURIComponent(SHARE_CODE) + '/adopted', 'POST', {});
    lastLocalChange = Date.now();
    write(items);
    refreshButtons();
    btn.textContent = added ? added + ' behang' + (added === 1 ? '' : 'en') + ' toegevoegd' : 'Staat al in je favorieten';
    btn.disabled = true;
  }

  function rerender() {
    var c = document.querySelector('[data-pp-favlist]');
    if (c) { renderList(c); showSampleButtons(c); }
    refreshButtons();
    if (tipEl && tipEl._place) tipEl._place();
  }

  // Actuele titel/foto/prijs ophalen (snapshot kan verouderd zijn); verdwenen producten eruit.
  function refreshFromLive() {
    var items = read();
    var pending = items.length;
    if (!pending) return;
    var changed = false;
    items.forEach(function (it) {
      if (!it.handle) { if (--pending === 0 && changed) rerender(); return; }
      fetch('/products/' + encodeURIComponent(it.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var cur = read();
          cur.forEach(function (x) {
            if (String(x.id) !== String(it.id)) return;
            var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
            if (p.price != null && x.price !== p.price) { x.price = p.price; changed = true; }
            if (p.title && x.title !== p.title) { x.title = p.title; changed = true; }
            if (!!x.priceVaries !== !!p.price_varies) { x.priceVaries = !!p.price_varies; changed = true; }
            if (!x.image && img) { x.image = img; changed = true; }
          });
          if (changed) write(cur);
        })
        .catch(function () {})
        .then(function () { if (--pending === 0 && changed) rerender(); });
    });
  }

  /* ---------- verwijder-bevestiging (bottom-sheet / pop-up) ---------- */
  var sheet = null;
  function openSheet(title, html) {
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'pp-sheet';
      sheet.innerHTML =
        '<div class="pp-sheet__overlay" data-pp-sheet-close></div>' +
        '<div class="pp-sheet__panel" role="dialog" aria-modal="true">' +
          '<h3 class="pp-sheet__title"></h3><div class="pp-sheet__body"></div>' +
        '</div>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) { if (e.target.closest('[data-pp-sheet-close]')) closeSheet(); });
    }
    sheet.querySelector('.pp-sheet__title').textContent = title;
    sheet.querySelector('.pp-sheet__body').innerHTML = html;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    return sheet.querySelector('.pp-sheet__body');
  }
  function closeSheet() { if (sheet) sheet.classList.remove('is-open'); }
  function confirmRemove(card) {
    var pid = card.getAttribute('data-product-id');
    var body = openSheet('Verwijderen?',
      '<p class="pp-sheet__text">Wil je <strong>' + esc(card.getAttribute('data-title')) + '</strong> uit je favorieten halen?</p>' +
      '<div class="pp-sheet__actions">' +
        '<button type="button" class="pp-favcard__btn" data-pp-remove-yes>Ja, verwijderen</button>' +
        '<button type="button" class="pp-favcard__btn pp-favcard__btn--ghost" data-pp-sheet-close>Annuleren</button>' +
      '</div>');
    body.querySelector('[data-pp-remove-yes]').addEventListener('click', function () {
      var items = read().filter(function (it) { return String(it.id) !== String(pid); });
      lastLocalChange = Date.now();
      write(items);
      syncToggle({ id: pid }, false);
      closeSheet();
      rerender();
    });
  }

  /* ---------- events ---------- */
  // Capture-fase: het hartje zit ín een klikbare productkaart (link) — voorkom navigeren.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pp-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }, true);
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-pp-fav-remove]');
    if (rm) { e.preventDefault(); confirmRemove(rm.closest('[data-pp-favcard]')); return; }
    var sh = e.target.closest('[data-pp-fav-share]');
    if (sh) { e.preventDefault(); share(sh.closest('[data-pp-favcard]')); return; }
    if (e.target.closest('[data-pp-share-list]')) { e.preventDefault(); shareList(); return; }
    var rf = e.target.closest('[data-pp-room-filter]');
    if (rf) { e.preventDefault(); FILTER = rf.getAttribute('data-pp-room-filter') || null; rerender(); return; }
    if (e.target.closest('[data-pp-tip-close]')) { e.preventDefault(); closeTip(); return; }
    var rr = e.target.closest('[data-pp-room-remove]');
    if (rr) { e.preventDefault(); removeRoom(rr.getAttribute('data-pp-room-remove'), rr.closest('[data-pp-favcard]').getAttribute('data-product-id')); return; }
    var ra = e.target.closest('[data-pp-fav-rooms]');
    if (ra) { e.preventDefault(); closeTip(); openRoomSheet(ra.closest('[data-pp-favcard]')); return; }
    var all = e.target.closest('[data-pp-shared-all]');
    if (all) { e.preventDefault(); adoptAllShared(all); return; }
    var sm = e.target.closest('[data-pp-fav-sample]');
    if (sm) { e.preventDefault(); openSampleSheet(sm.closest('[data-pp-favcard]')); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  // Nieuwe productkaarten (filteren, oneindig scrollen, quick-view) → hartjes bijwerken.
  var moTimer = null;
  new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(function () { refreshButtons(); updateCounts(read().length); }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function init() {
    refreshButtons();
    updateCounts(read().length);
    var c = document.querySelector('[data-pp-favlist]');
    if (c && SHARED) {
      var t = c.querySelector('[data-pp-favlist-title]');
      var own = c.querySelector('[data-pp-own]'); if (own) own.hidden = true;
      var sh = c.querySelector('[data-pp-shared]'); if (sh) sh.hidden = false;
      var setTitle = function () { if (t) t.textContent = SHARED_TITLE || 'Gedeeld lijstje'; };
      setTitle();
      if (SHARE_CODE) {
        renderList(c);
        api('/share/' + encodeURIComponent(SHARE_CODE), 'GET').then(function (res) {
          if (!res || !res.ok) {
            var p = sh && sh.querySelector('.pp-fav-cta__text');
            if (p) p.textContent = 'Deze link werkt niet (meer). Vraag de afzender om het lijstje opnieuw te delen.';
            var all = sh && sh.querySelector('[data-pp-shared-all]'); if (all) all.hidden = true;
            return;
          }
          SHARED_TITLE = res.title || null; setTitle();
          SHARED = (res.items || []).map(function (x) { return sharedItem(x.handle, x.rooms); });
          fillShared(c);
        });
      } else { renderList(c); fillShared(c); }
    } else if (c) { renderList(c); showSampleButtons(c); refreshFromLive(); setTimeout(function () { maybeShowRoomTip(c); }, 600); }
    syncAccount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.PPFav = {
    all: read,
    count: function () { return read().length; },
    isLoggedIn: function () { return !!CUSTOMER; }
  };
})();
